import { dateSorter, entityNameSorter, getProp, periodRenderer, priceRenderer } from '@lib/generic.utils'
import { agPriceCol } from '@/ag-grid/ag-columns'
// Components
import ActionsColumn from './ActionsColumn'

export const options = {
  computed: {
    options() {
      return {
        columnDefs: [
          {
            headerName: 'Vendor',
            field: 'vendor',
            comparator: entityNameSorter,
            cellRenderer: params => getProp(params.value, 'name', 'N/A')
          },

          {
            headerName: 'Publisher',
            field: 'publisher',
            comparator: entityNameSorter,
            cellRenderer: params => getProp(params.value, 'name', 'N/A')
          },

          {
            headerName: 'Product',
            field: 'name'
          },

          {
            headerName: 'Subscription period',
            comparator: dateSorter,
            cellRenderer: params => periodRenderer(params.data)
          },

          agPriceCol('Last period price', 'price_last_period', {
            cellRenderer: params => priceRenderer(params.value)
          }),

          agPriceCol('Forecasted Price', 'forecasted_price', {
            editable: true,
            cellClass: ['editable-cell', 'ag-right-aligned-cell'],
            cellRenderer: params => priceRenderer(params.value)
          }),

          agPriceCol('List price', 'list_price', {
            editable: true,
            cellClass: ['editable-cell', 'ag-right-aligned-cell'],
            cellRenderer: params => priceRenderer(params.value)
          }),

          agPriceCol('First offer', 'first_offer_price', {
            editable: true,
            cellClass: ['editable-cell', 'ag-right-aligned-cell'],
            cellRenderer: params => priceRenderer(params.value)
          }),

          agPriceCol('Final offer', 'price', {
            editable: true,
            cellClass: ['editable-cell', 'ag-right-aligned-cell'],
            cellRenderer: params => priceRenderer(params.value)
          }),

          {
            headerName: 'Currency',
            field: 'currency',
            minWidth: 75,
            maxWidth: 75
          },

          {
            headerName: 'Actions',
            minWidth: 90,
            maxWidth: 90,
            sortable: false,
            resizable: false,
            lockVisible: true,
            cellRendererFramework: ActionsColumn
          }
        ]
      }
    }
  }
}
